import {createSelector} from 'reselect'
import selectorsGenerator from '../comments/selectorsGenerator'
import {getCustomers, getProjects} from '../../entities/selectors'
import {getEditableCustomerIds, getEditableProjectIds} from '../../taskManagement/common/selectors'

const getProjectPanelState = state => state.panels.project

export const getOpenProjectId = state => getProjectPanelState(state).openProjectId
export const isAllTasksAssigned = state => getProjectPanelState(state).allTasksAssigned
export const isCommentsReadOnly = state => !isAllTasksAssigned(state)
export const canManage = state => getProjectPanelState(state).canManage

const commentsSelector = selectorsGenerator(getProjectPanelState)

export const getComments = commentsSelector.getComments
export const getUsers = commentsSelector.getUsers
export const getCommentsCount = commentsSelector.getCommentsCount
export const getAllCommentsUserIds = commentsSelector.getAllCommentsUserIds
export const getRecentlyAddedCommentsIds = commentsSelector.getRecentlyAddedCommentsIds
export const needMoreComments = commentsSelector.needMoreComments
export const isNewCommentsOnTop = commentsSelector.isNewCommentsOnTop
export const getNewestCommentId = commentsSelector.getNewestCommentId
export const getCommentsScrollTo = commentsSelector.getCommentsScrollTo
export const getEditingCommentId = commentsSelector.getEditingCommentId
export const getEditingCommentText = commentsSelector.getEditingCommentText
export const isCommentsLoading = commentsSelector.isLoading
export const isSendingComment = commentsSelector.isSendingComment
export const getUpdatingCommentId = commentsSelector.getUpdatingCommentId
export const getNewCommentsTexts = commentsSelector.getNewCommentsTexts

export const getProjectNewComment = createSelector(
    getOpenProjectId,
    commentsSelector.getNewCommentsTexts,
    (taskId, comments) => comments[taskId] ? comments[taskId] : ''
)

export const isShowNewCommentInput = createSelector(
    commentsSelector.isShowNewCommentInput,
    getOpenProjectId,
    commentsSelector.getNewCommentsTexts,
    (showInput, projectId, comments) => showInput || comments[projectId] !== undefined
)

const getCustomerId = createSelector(
    getOpenProjectId,
    getProjects,
    (id, projects) => {
        return projects[id] ? projects[id].customerId : -1
    }
)

const getCustomer = createSelector(
    getCustomerId,
    getCustomers,
    (id, customers) => {
        return (customers[id]) ? customers[id] : null
    }
)

const getProject = createSelector(
    getOpenProjectId,
    getProjects,
    (id, projects) => {
        return (projects[id]) ? projects[id] : null
    }
)

export const canReopenProject = createSelector(
    getOpenProjectId,
    getProject,
    isAllTasksAssigned,
    getCustomerId,
    getCustomer,
    getEditableProjectIds,
    getEditableCustomerIds,
    (projectId, project, isAllTasksAssigned, customerId, customer, editableProjectIds, editableCustomerIds) => {
        return (!!project && !project.archived) || (!!editableProjectIds[projectId] && !!customer && !customer.archived) || !!editableCustomerIds[customerId]
    }
)

export const canMoveProject = createSelector(
    getOpenProjectId,
    getEditableProjectIds,
    (projectId, editableProjectIds) => {
        return !!editableProjectIds[projectId]
    }
)

export const isPanelOpenedFromUrl = createSelector(
    getProjectPanelState,
    panelState => panelState.openedFromUrl
)



// WEBPACK FOOTER //
// ./web/js/panels/project/selectors.js